import { render, staticRenderFns } from "./RenewalDashboardTextareaComponent.vue?vue&type=template&id=05aee14b&scoped=true"
import script from "./RenewalDashboardTextareaComponent.vue?vue&type=script&lang=js"
export * from "./RenewalDashboardTextareaComponent.vue?vue&type=script&lang=js"
import style0 from "./RenewalDashboardTextareaComponent.vue?vue&type=style&index=0&id=05aee14b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aee14b",
  null
  
)

export default component.exports